export default __webpack_public_path__ + "static/media/illustration-algostudy-m@3x.d77e787e.webp";